import React from 'react';
import { clientLogos } from '../data/mock';

const Clients = () => {
  return (
    <section className="bg-white py-24 px-8">
      <div className="max-w-[1200px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-6 tracking-tight">
            Clients
          </h2>
          <p className="text-xl text-gray-700 max-w-[800px] mx-auto leading-relaxed">
            We're privileged to work with some of the industry's top companies, helping them build their brand for the now.
          </p>
        </div>

        {/* Client Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-12 items-center justify-items-center">
          {clientLogos.map((client) => (
            <div 
              key={client.id}
              className="flex items-center justify-center p-6 transition-all duration-300 hover:scale-110"
            >
              <img 
                src={client.logo}
                alt={client.name}
                className="w-full h-24 object-contain grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
